<template>
  <div>
    <section class="content">
      <div class="row center-block">
        <div class="box">
          <!-- Box Header -->
          <div class="box-header">
              <div class="row">
                  <h3 align="center">Kobe Tech Team</h3>
              </div>
          </div>

          <!-- Box Body -->
          <div class="box-body">
           
               <div class="row">
              <input
                type="text"
                class="col-xs-offset-2 col-xs-8"
                id="email"
                v-model="email"
                placeholder="Email"
              >
            </div>
            <div class="row">
              <div class="col-md-12" align="center">
                <a id="check-btn" class="btn text-uppercase" @click="check">Check</a>
                <a id="create-btn" class="btn text-uppercase" @click="create">Create</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import expressGatewayAPI from '../express-gateway.api.js'
export default {
  name: 'ExpressGateWayUsers',
  data() {
    return {
      email: ''
    }
  },
  methods: {
    check: function() {
      expressGatewayAPI.checkExistdUser(this.email).then((resp) => {
        this.$swal({
          title: 'Found!!!',
          text: 'User already existed',
          type: 'success'
        })
      }).catch(() => {
        this.$swal({
          title: 'Not Found!!!',
          text: 'User does not exist',
          type: 'error',
          buttons: ['Create User']
        })
      })
    },
    create: function() {
      expressGatewayAPI.createUserGateWay(this.email).then((resp) => {
        this.$swal({
          title: 'Success',
          text: 'Created',
          type: 'success'
        })
      }).catch((error) => {
        console.error(error)
        this.$swal({
          title: 'Error',
          text: error.message,
          type: 'error'
        })
      })
    }
  }
}
</script>

<style>
#email {
  height: 50px;
  border: 3px solid #3c8dbc;
  border-radius: 10px;
  text-align: center;
  font-size: medium;
  margin-top: 10px;
}

#email:focus {
  outline: none;
}

#check-btn {
  font-size: x-large;
  background: #3c8dbc;
  color: white;
  margin-top: 20px;
}
#create-btn {
  font-size: x-large;
  background: #3cbc58;
  color: white;
  margin-top: 20px;
}

#try_this_link {
  font-size: large;
}
</style>



// WEBPACK FOOTER //
// index.vue?ccbad434